// uses ./appsListItems.less
import PropTypes from 'prop-types';

import React from 'react';
import Banners from '../banners/Banners';
import AllApps from './AllApps';
import FeaturedApps from './FeaturedApps';
import IntegrationsApps from './IntegrationsApps';
import EgnyteApps from './EgnyteApps';
import Loading from '../../common/Loading';

const AppsListItems = ({ apps, shouldDisplaySections, isFetching }) => (
    <section className="appsListItems" id="appsListItems">
        <Loading isLoaded={!isFetching}>
            {shouldDisplaySections ? (
                <div className="appsListItemsContent">
                    <Banners />
                    <FeaturedApps apps={apps} />
                    <EgnyteApps apps={apps} />
                    <IntegrationsApps apps={apps} />
                </div>
            ) : (
                <div className="appsListItemsContent appsListItemsContent--withoutSection">
                    <AllApps apps={apps} />
                </div>
            )}
        </Loading>
    </section>
);

AppsListItems.propTypes = {
    apps: PropTypes.array.isRequired,
    isFetching: PropTypes.bool.isRequired,
    shouldDisplaySections: PropTypes.bool.isRequired,
};

export default AppsListItems;
